import { cn } from '@util/index';
import type { ProductDocument } from 'models/product';
import type { UserDocument } from 'models/user';

type ProductShippingEstimateProps = {
  product: ProductDocument;
  userDoc: UserDocument | null | undefined;
  whiteText?: boolean;
};

export default function ProductShippingEstimate({
  ...props
}: ProductShippingEstimateProps) {
  const isMXLockerDirect =
    props.product.seller_id === 'E16WuBcn0UMejlp0FSdQulSSed12';
  const deliveryRange = isMXLockerDirect ? '1-3' : '2-5';
  const isFreeShipping =
    props.product.is_flat_rate &&
    props.product.shipping_costs?.every(({ cost }) => cost === 0);

  if (!isFreeShipping) return null;

  if (isMXLockerDirect) {
    return (
      <div className="flex items-center gap-2 text-black">
        <span className="text-[1.6rem] font-medium text-zinc-600 sm:text-[1.7rem]">
          Free delivery in {deliveryRange} biz days
        </span>
      </div>
    );
  }

  return (
    <span
      className={cn(
        'text-[1.6rem] font-medium sm:text-[1.7rem]',
        props.whiteText ? 'text-zinc-300' : 'text-zinc-600'
      )}
    >
      Free delivery
    </span>
  );
}
